import type { TreeItemContextMenuOption } from './TreeItem';

/**
 * Tree menus often have one extra action that may be absent.
 * Keep that check here so each menu does not repeat it.
 * Return the original list when the action is missing, so the caller keeps the same array.
 */
export function appendOptionalContextMenuOption(
  options: TreeItemContextMenuOption[],
  option: TreeItemContextMenuOption | undefined
): TreeItemContextMenuOption[] {
  return option === undefined ? options : [...options, option];
}
